import PropTypes from 'prop-types';
import { useState } from 'react';
import { Formik } from 'formik';
import { Link } from 'react-router-dom';
import MKBox from 'components/MaterialKit/MKBox';
import MKInput from 'components/MaterialKit/MKInput';
import MKTypography from 'components/MaterialKit/MKTypography';
import Button from 'components/Button';

const BuddhistLoginForm = ({ onLogin,
  initialValues,
  buttonColor,
  buttonTitle,
  usernameLabel,
  passwordLabel,
  showSignUp,
  showForgotPassword,
  textColor,
  forgotPasswordUrl,
  registerUrl,
  title,
  loginLabel,
  dontHaveAccountLabel,
  signUpNowLabel,
  showSignUpLoginSignupViaOthers,
  loginSignupViaOthersLabel,
  forgotPasswordLabel,
  loginAsAdminLabel,
  showLoginAsAdmin,
  loginAsUserLabel,
  ...props }) => {
  const [loginAsAdmin, setLoginAsAdmin] = useState(false);
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onLogin}
      {...props}
    >
      {({ handleChange, handleBlur, handleSubmit, errors, values, isSubmitting, touched }) => {
        return (
          <MKBox
            component="form"
            role="form"
            onSubmit={handleSubmit}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <MKBox
              display="flex"
              padding={5}
              alignItems="center"
              flexDirection="column"
              sx={{
                width: '100%',
                maxWidth: '540px',
                backgroundColor: '#f4f4f8',
              }}
            >
              <MKTypography fontSize={25} mb={3}>
                {title}
              </MKTypography>
              <MKBox mb={2} display="flex" flexDirection="column" sx={{ width: '100%' }}>
                <MKBox display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
                  <MKTypography fontSize={15}>
                    {usernameLabel}
                  </MKTypography>
                  {showLoginAsAdmin && (
                    <MKTypography variant="button" color={textColor || 'text'} fontSize={15}>
                      <MKTypography
                        component={Link}
                        onClick={() => { setLoginAsAdmin(!loginAsAdmin); }}
                        variant="button"
                        color={textColor || 'info'}
                        fontWeight="medium"
                      >
                        {!loginAsAdmin ? loginAsAdminLabel : loginAsUserLabel}
                      </MKTypography>
                    </MKTypography>
                  )}
                </MKBox>
                <MKInput
                  name="username"
                  value={values.username || ''}
                  onChange={handleChange('username')}
                  onBlur={handleBlur('username')}
                  fullWidth
                />
              </MKBox>
              <MKBox mb={2} display="flex" flexDirection="column" sx={{ width: '100%' }}>
                <MKBox display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
                  <MKTypography fontSize={15}>
                    {passwordLabel}
                  </MKTypography>
                  {showForgotPassword && (
                    <MKTypography variant="button" color={textColor || 'text'} fontSize={15}>
                      <MKTypography
                        component={Link}
                        to={forgotPasswordUrl || '/forgot'}
                        variant="button"
                        color={textColor || 'info'}
                        fontWeight="medium"
                      >
                        {forgotPasswordLabel}
                      </MKTypography>
                    </MKTypography>
                  )}
                </MKBox>
                <MKInput
                  name="password"
                  type="password"
                  value={values.password || ''}
                  onChange={handleChange('password')}
                  onBlur={handleBlur('password')}
                  fullWidth
                />
              </MKBox>
              {!!errors.form && (
                <MKTypography variant="caption" color="error">{errors.form}</MKTypography>
              )}
              <MKBox mt={4} mb={3} display="flex" width="100%">
                <Button type="submit" variant="gradient" color={buttonColor || 'info'} size="large" fullWidth disabled={isSubmitting} fontSize={15}>
                  {loginLabel}
                </Button>
              </MKBox>
              {showSignUp && !loginAsAdmin && (
                <MKBox display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="100%" mt={2}>
                  <MKTypography fontSize={15} variant="button" color={textColor}>
                    {dontHaveAccountLabel}
                  </MKTypography>
                  <Button style={{ backgroundColor: 'transparent', color: buttonColor, border: `1px solid ${buttonColor}` }}>
                    {signUpNowLabel}
                  </Button>
                </MKBox>
              )}
              {showSignUpLoginSignupViaOthers && !loginAsAdmin && (
                <MKBox display="flex" flexDirection="row" justifyContent="space-between" alignItems="flex-end" width="100%" mt={2}>
                  <MKTypography fontSize="1vw" variant="button" color="gray">
                    ____________
                  </MKTypography>
                  <MKTypography fontSize={15} variant="button" color={textColor}>
                    {loginSignupViaOthersLabel}
                  </MKTypography>
                  <MKTypography fontSize="1vw" variant="button" color="gray">
                    ____________
                  </MKTypography>
                </MKBox>
              )}
            </MKBox>
          </MKBox>
        );
      }}
    </Formik>
  );
};

BuddhistLoginForm.propTypes = {
  onLogin: PropTypes.func,
  initialValues: PropTypes.object,
  showSignUp: PropTypes.bool,
  showForgotPassword: PropTypes.bool,
  usernameLabel: PropTypes.string,
  passwordLabel: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonTitle: PropTypes.string,
  textColor: PropTypes.string,
  forgotPasswordUrl: PropTypes.string,
  registerUrl: PropTypes.string,
  title: PropTypes.string,
  loginLabel: PropTypes.string,
  dontHaveAccountLabel: PropTypes.string,
  signUpNowLabel: PropTypes.string,
  loginSignupViaOthersLabel: PropTypes.string,
  showSignUpLoginSignupViaOthers: PropTypes.bool,
  forgotPasswordLabel: PropTypes.string,
  loginAsAdminLabel: PropTypes.string,
  showLoginAsAdmin: PropTypes.bool,
  loginAsUserLabel: PropTypes.string,
};

BuddhistLoginForm.defaultProps = {
  onLogin: () => {},
  initialValues: {},
};

export default BuddhistLoginForm;
